export default function Concept() {
  return (
    <section id="concept" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <p className="text-sm text-gray-500 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>Our Philosophy</p>
          <h2 className="text-5xl font-bold leading-tight" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            <span className="block text-gray-900">私たちが大切にする</span>
            <span className="block text-6xl italic text-rose-600 my-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>3つの価値観</span>
            <span className="block text-gray-900">Three Core Values</span>
          </h2>
          <p className="text-base text-gray-600 mt-6 max-w-3xl mx-auto leading-relaxed">
            「絵 仕事」は、単なるイラストレーション制作会社ではありません。<br />
            クライアント様のビジョンを深く理解し、視覚的な物語として表現することで、<br />
            ブランドと顧客の心をつなぐ架け橋となることを使命としています。
          </p>
        </div>

        <div className="mt-16 bg-white rounded-3xl p-12 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-20 h-20 bg-rose-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-team-line text-4xl text-rose-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                経験豊富なチーム
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                美術大学卒業のプロフェッショナルイラストレーター5名、アートディレクター2名、プロジェクトマネージャー2名の計9名体制。各メンバーが得意分野を持ち、協力してプロジェクトを推進します。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-4xl text-orange-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                柔軟な納期対応
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                通常2〜4週間の制作期間を基本としながら、お急ぎの案件にも可能な限り対応いたします。スケジュール管理を徹底し、納期厳守を約束します。
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-teal-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                安心の修正対応
              </h4>
              <p className="text-sm text-gray-600 leading-relaxed">
                初稿提出後、3回までの修正を無料で対応。ご満足いただけるまで丁寧に調整いたします。著作権譲渡も含め、安心してご利用いただける契約内容をご用意しています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}